// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const IconUserRemoveIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "IconUserRemove/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M13 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0ZM9 14a6 6 0 0 0-6 6v1h12v-1a6 6 0 0 0-6-6ZM21 12h-6"
}));
export default IconUserRemoveIcon;